export default __webpack_public_path__ + "paddle_exploit8c2d7b.png";